<footer class="bottom-footer">
    <div class="container-fluid">
        <div class="row center-align">
           
            <div class="col-md-4">
                <app-socil-media></app-socil-media>
            </div>

            <div class="col-md-4">
                <p class="copy mb-0 text-black">
                    {{"All rights reserved to Codes Roots" | translate}}
                </p>
            </div>     
            
            <div class="col-md-4">
                <p class="copy mb-0 ms-lg-5 text-black">
                    {{"Commercial Registration Number: 72647" | translate}}
                </p>
            </div> 

            
        </div>
    </div>
</footer>